import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faArrowRight,
  faGripVertical,
  faLock,
  faLockOpen,
  faUser,
  faChalkboardTeacher,
  faCheck,
  faXmark,
  faEnvelope,
  faEye,
  faCopy
} from '@fortawesome/free-solid-svg-icons'

export const registerIconsToLibrary = () => {
  library.add(faGripVertical)
  library.add(faChalkboardTeacher)
  library.add(faUser)
  library.add(faLock)
  library.add(faLockOpen)
  library.add(faArrowRight)
  library.add(faCheck)
  library.add(faXmark)
  library.add(faEye)
  library.add(faEnvelope)
  library.add(faCopy)
}
